import { useAuth } from "react-oidc-context";

export function useIsPinCodeUser() {
  const { user } = useAuth();
  const pinCodeLoginLabel = 'local';

  return user?.profile.idp === pinCodeLoginLabel;
};